<template>
  <el-dialog 
    :title="$t('mis.appAbChannel.blacklist.title')" 
    :visible.sync="visible" 
    width="70%" 
    :close-on-click-modal="false"
    append-to-body>
    
    <div style="margin-bottom: 15px;">
      <el-button type="primary" icon="el-icon-plus" @click="handleAdd">
        {{ $t('mis.bt.add') || 'Add IP' }}
      </el-button>
    </div>

    <table-page 
      ref="childTable" 
      :pageData="pageData" 
      @btnclick="handleTableBtnClick">
    </table-page>

    <UPDATE 
      ref="childUpdate" 
      @submit="submitAdd" 
      :updateData="updateData">
    </UPDATE>

    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('mis.bt.close') || 'Close' }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import tablePage from "@/components/page/table.vue";
import UPDATE from "@/components/page/update.vue";
import { dataChange } from '@/utils/dataChange';
import URL from "@/views/mis/util/url"; 

// IPv4 正則表達式
const IPV4_REGEX = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

export default {
  name: "BlacklistDialog",
  components: {
    tablePage,
    UPDATE
  },
  data() {
    return {
      visible: false,
      // 表格配置
      pageData: {
        fieldTotal: "recordsFiltered", 
        fieldData: "data",
        queryUrl: URL.appAbChannel.blacklistQuery || '/app-ab-channel/blacklist/list', 
        method: "post",
        sequence: true,
        isPage: true,
        size: 10,
        cols: [
          { title: window.$t("mis.appAbChannel.blacklist.table.id"), field: "id", hidden: true },
          { title: window.$t("mis.appAbChannel.blacklist.table.ipAddress"), field: "ip", minWidth: "150" },
          { title: window.$t("mis.appAbChannel.blacklist.table.remark"), field: "remark", minWidth: "150" },
          { title: window.$t("mis.common.createdAt") || "Created At", field: "createdAt", minWidth: "160" },
          { title: window.$t("mis.common.createdBy") || "Created By", field: "createdBy", minWidth: "120" },
          { 
            title: window.$t("mis.bt.operation") || "Operation", 
            btnClick: [
              { 
                name: window.$t("mis.bt.delete") || "Delete", 
                click: "delete", 
                type: "danger", 
                icon: "el-icon-delete",
                size: "mini"
              }
            ]
          }
        ]
      },
      // 新增表單配置
      updateData: {
        modelName: window.$t('mis.appAbChannel.blacklist.modal.title'),
        width: "500px",
        cols: [
          { 
            title: window.$t('mis.appAbChannel.blacklist.modal.ipAddress.label'), 
            field: "ip", 
            required: (model) => {
               if (!model.ip) return true; // 必填校驗
               // 正則校驗
               if (!IPV4_REGEX.test(model.ip)) {
                 return true;
               }
               return true;
            },
            placeholder: window.$t('mis.appAbChannel.blacklist.modal.ipAddress.placeholder') 
          },
          { 
            title: window.$t('mis.appAbChannel.blacklist.modal.remark.label'), 
            field: "remark", 
            type: 1, // 普通輸入框
            placeholder: window.$t('mis.appAbChannel.blacklist.modal.remark.placeholder') 
          }
        ]
      }
    };
  },
  methods: {
    // 父組件調用此方法打開對話框
    open() {
      this.visible = true;
      // 等待 DOM 渲染後加載數據
      this.$nextTick(() => {
        this.refreshTable();
      });
    },

    // 刷新表格數據
    refreshTable() {
      if (this.$refs.childTable) {
        // 顯式傳遞 pageNum 和 pageSize，確保初始請求參數與翻頁時完全一致
        // 改用 defaultQueryData，它會在組件內部將當前頁碼重置為 1，避免從第 2 頁關閉彈窗再打開時狀態錯亂
        this.$refs.childTable.defaultQueryData({
          pageNum: 1,
          pageSize: this.pageData.size || 15
        });
      }
    },

    // 點擊新增按鈕
    handleAdd() {
      // 調用 update.vue 的 open 方法，傳入空對象重置表單
      this.$refs.childUpdate.open({});
    },

    // 處理新增表單提交
    submitAdd(formData) {
      // 前端校驗 IP 格式
      if (!IPV4_REGEX.test(formData.ip)) {
        this.$message.error(window.$t("mis.appAbChannel.blacklist.message.invalid"));
        // 手動停止 update.vue 的 loading 狀態 (如果有的話)
        this.$refs.childUpdate.changeSubmitBtnStatus(false);
        return;
      }

      const url = URL.appAbChannel.blacklistAdd || '/app-ab-channel/blacklist/add';
      
      dataChange(url, formData, (res) => {
        if (res.code === 0 || res.code === 200) {
          this.$message.success(window.$t("mis.appAbChannel.message.success") || "Success");
          this.$refs.childUpdate.close(); // 關閉新增彈窗
          this.refreshTable(); // 重載表格
        } else {
          // 處理後端返回的業務錯誤 (如 10001, 10002)
          this.$message.error(res.message || window.$t("mis.appAbChannel.message.fail"));
          this.$refs.childUpdate.changeSubmitBtnStatus(false);
        }
      }, (err) => {
        this.$message.error(window.$t("mis.appAbChannel.message.fail"));
        this.$refs.childUpdate.changeSubmitBtnStatus(false);
      }, "POST", "json");
    },

    // 處理表格內按鈕點擊 (刪除)
    handleTableBtnClick(clickName, row) {
      if (clickName === 'delete') {
        this.doDelete(row.id);
      }
    },

    doDelete(id) {
      if (!id) return;

      const baseUrl = URL.appAbChannel.blacklistDelete || '/app-ab-channel/blacklist/delete/';
      const url = `${baseUrl}${id}`;

      dataChange(url, {}, (res) => {
        if (res.code === 0 || res.code === 200) {
          this.$message.success(window.$t("mis.appAbChannel.message.success") || "Deleted successfully");
          this.refreshTable();
        } else {
          this.$message.error(res.message || window.$t("mis.appAbChannel.message.fail"));
        }
      }, (err) => {
        this.$message.error(window.$t("mis.appAbChannel.message.fail"));
      }); 
    }
  }
};
</script>

<style scoped>
/* 可根據需要添加樣式 */
</style>